import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{staticClass:"loadingscreen-cont"},[_c('img',{staticClass:"loadingscreen-img",attrs:{"src":_vm.qmkey_icon}}),_c('div',{staticClass:"loadingscreen-progress-cont"},[_c(VProgressLinear,{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }